/**
 * Cuestionario de feedback del alumno (NPS + valoraciones + abiertas).
 * Endpoints /api/users/me/feedback/*.
 */

import { ApiClient } from './client';

export interface FeedbackStatus {
  show: boolean;
  reason?: string;
  activeDays?: number;
}

export interface FeedbackSubmitPayload {
  /** 0-10, obligatorio. */
  nps: number;
  npsReason?: string;
  /** 1-4 (Nada..Mucho). */
  progress?: number | null;
  /** 'easy' | 'right' | 'hard'. */
  levelFit?: string | null;
  /** 1-4 (Muy difícil..Muy fácil). */
  easeOfUse?: number | null;
  /** Multi-selección: 'stories' | 'conversation' | 'vocabulary' | 'gamification' | 'rewards'. */
  topFeatures?: string[];
  improvement?: string;
}

export const feedbackAPI = {
  /** ¿Debe mostrarse el cuestionario ahora? */
  getStatus: (): Promise<FeedbackStatus> =>
    ApiClient.get<FeedbackStatus>('/users/me/feedback/status'),

  /** Marca que el drawer se ha mostrado (para el reintento único). */
  markShown: (): Promise<{ ok: boolean }> =>
    ApiClient.post<{ ok: boolean }>('/users/me/feedback/shown', {}),

  /** Guarda la respuesta del alumno. */
  submit: (payload: FeedbackSubmitPayload): Promise<{ ok: boolean }> =>
    ApiClient.post<{ ok: boolean }>('/users/me/feedback', payload),
};
